import { useTranslation } from "react-i18next";
import { IconMenu2, IconLogout } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/layout/NotificationBell";
import { useAuthStore } from "@/features/auth/stores/authStore";

export function Topbar({ onMenuClick }: { onMenuClick?: () => void }) {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  const initials = (user?.developerName ?? "ImobGo")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border bg-white/80 px-3 backdrop-blur md:px-5">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Abrir menu"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-ink-muted hover:bg-bg lg:hidden"
      >
        <IconMenu2 size={20} />
      </button>

      <div className="flex-1" />

      <div className="flex items-center gap-2">
        <NotificationBell />
        <div className="hidden text-right sm:block">
          <p className="text-[13px] font-semibold leading-tight">{user?.developerName}</p>
          <p className="text-[11px] text-ink-muted">{user?.email}</p>
        </div>
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-[12px] font-semibold text-brand-700">
          {initials}
        </span>
        <Button variant="ghost" size="icon" aria-label={t("actions.logout")} onClick={logout}>
          <IconLogout size={18} />
        </Button>
      </div>
    </header>
  );
}
